<template>
    <div class="footer">
        <div class="center">
          Made by <a target="_blank" href="https://jonmarcello.ca">Jonathan Marcello</a>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>